import { useCache } from "@/hooks/useCache";
import { useFilterUnit } from "@/hooks/useFilter";
import type { Spice } from "@/data/schema";

export function Ingredients({ spices }: { spices: Map<number, Spice> }) {
  const [unit] = useFilterUnit();
  const { data } = useCache();
  if (!data || spices.size === 0) return null;

  return (
    <>
      <div>
        <h3 className="text-base font-semibold text-secondary mb-3 -mx-2 px-2">Ingredients</h3>
        <div className="space-y-1.5">
          {Array.from(spices.entries()).map(([id, s]) => {
            const portion = data[Number(id)]?.portions?.[unit];
            return (
              <div className="flex items-center gap-4 py-2 rounded hover:bg-primary/5 transition-colors" key={id}>
                <p className="text-main/80 flex-1 min-w-0 truncate">{s.name}</p>
                <div className="w-20 flex-shrink-0">
                  <p className="text-secondary">{portion ? Math.round(s.quantity / portion) : 0}</p>
                </div>
                <div className="w-12 flex-shrink-0">
                  <p className="text-main/60 text-sm">{unit}</p>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </>
  );
}
